const AUTH_STORAGE_KEY = 'mpl_auth_session';
const TOKEN_TTL_MS = 60 * 24 * 60 * 60 * 1000; // 60 days

const VALID_USERNAME = 'altosight';
const VALID_PASSWORD = 'd61ccd240f7707cf';

function readSession() {
    try {
        const raw = localStorage.getItem(AUTH_STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

function writeSession(session) {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
}

export function isAuthenticated() {
    const session = readSession();
    if (!session?.token || !session?.expiresAt) return false;
    if (Date.now() >= session.expiresAt) {
        clearAuth();
        return false;
    }
    return true;
}

export function clearAuth() {
    localStorage.removeItem(AUTH_STORAGE_KEY);
}

export function login(username, password) {
    if (username !== VALID_USERNAME || password !== VALID_PASSWORD) {
        return { ok: false, error: 'Invalid username or password' };
    }

    const tokenBytes = new Uint8Array(32);
    crypto.getRandomValues(tokenBytes);
    const token = Array.from(tokenBytes, (b) => b.toString(16).padStart(2, '0')).join('');

    writeSession({
        token,
        username,
        expiresAt: Date.now() + TOKEN_TTL_MS,
    });

    return { ok: true };
}
